import { usePayPeriodTimeRangeGet, useWeeklyTimeRangeGet } from 'hooks';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { DashboardTimeFrame } from '../types/types';
import { LuxonZone } from 'types/LuxonZone';
import { utcToday } from 'utils/dateUtils';

export function useDashboardTimeRange(timeFrame: DashboardTimeFrame, zone: LuxonZone) {
  const weeklyRangeGet = useWeeklyTimeRangeGet(zone);
  const payPeriodRangeGet = usePayPeriodTimeRangeGet(zone);

  return useMemo(() => {
    const currentTime = zone === 'utc' ? utcToday().startTime : DateTime.local().startOf('day');

    switch (timeFrame) {
      case 'payPeriod':
        return payPeriodRangeGet(currentTime.toSeconds());
      case 'weekly':
        return weeklyRangeGet(currentTime.toSeconds());
      case 'pastSeven':
        return {
          startTime: currentTime.minus({ days: 6 }),
          endTime: currentTime.endOf('day').startOf('second'),
        };
      case 'pastFourteen':
        return {
          startTime: currentTime.minus({ days: 13 }),
          endTime: currentTime.endOf('day').startOf('second'),
        };
      case 'monthly':
      default:
        return {
          startTime: currentTime.startOf('month'),
          endTime: currentTime.endOf('day').startOf('second'),
        };
    }
  }, [payPeriodRangeGet, timeFrame, weeklyRangeGet, zone]);
}
